export default {
  labels: {
    title: 'Delivery relationship',
    searchBar: 'Search by delivery relationship number or invoice number',
    statuses: 'Status',
    originInvoiceGroupId: 'Delivery relationship number',
    path: 'Path',
    status: 'Status',
    settlementNumber: 'Settlement Number',
    detailTitle: 'Delivery relationship detail',
    generalInformation: 'General information',
    files: 'Rips files',
    invoices: 'Invoices',
    extension: 'Extension',
    fileName: 'File name',
    invoiceNumber: 'Invoice number',
    packageStatus: 'Package status',
    externalId: 'External Id',
    actions: 'Actions',
    packageFolderConfiguration: 'Folder configuration',
    generateAccountButton: 'Build delivery relationship',
    reGenerateAccountButton: 'Rebuild delivery relationship',
  },
  dialogText: {
    generateAccount: {        
      title: 'Do you want to build the delivery relationship?',
      subtitle: 'This delivery relationship has ({count}) invoice to build. Are you sure you want to proceed? This action cannot be undone or stopped. | This delivery relationship has ({count}) invoices to build. Are you sure you want to proceed? This action cannot be undone or stopped.',
    },
    preSettlementAction: {
      title: 'Do you want to do this action with the invoices of this delivery relationship?',
      subtitle: 'This delivery relationship has ({count}) invoice to process. Are you sure you want to proceed? | This delivery relationship has ({count}) invoices to process. Are you sure you want to proceed?',
    },
    preSettlementRipsValidationErrors: {
      title: 'Do you want to change the status of the delivery relationship?',
      subtitle: 'The delivery relationship will be marked with the RIPS file validation error status. Are you sure you want to proceed?',
    }
  },
  statuses: {
    PENDING: 'Pending',
    READY_TO_GENERATE: 'Ready to generate',
    GENERATED: 'Generated',
    SETTLED: 'Settled',
    SENT: 'Sent',
    VOIDED: 'Voided',
    RIPS_VALIDATION_ERRORS: 'RIPS file validation error',
  },
  actions: {
    setAccountsAsPackageGenerated: 'Set as Generated',
    setAccountsAsSettled: 'Set as Settled',
    setAccountsAsSent: 'Set as Sent to settlement',
    setAccountsAsRipsValidationErrors: 'Set as RIPS file validation error',
  },
  errors: {
    downloadFile: 'An error occurred while downloading the file. Please try again or contact your technical support team.',
  },
  package: {
    globalConfigurationHint: 'This configuration applies to all agreements that do not have a specific path',
    configurationByAgreement: 'Configuration by agreement',
    generalConfiguration: 'General configuration',
    addConfigurationByAgreement: 'Add configuration by agreement',
    deleteWarning: 'Are you sure you want to delete the configuration?',
    deleteWarningMessage: 'The configuration will be replaced by the general configuration',
    duplicatedAgreement: 'Are you sure you want to replace it? This will change the agreement binding configuration {agreementCodes}',
    headers: {
      agreementCodes: 'Agreement codes',
      path: 'Path',
      actions: 'Actions'
    }
  }
}
